const pageUnloadEvent = {
  event: 'page_unload',
};

export default pageUnloadEvent;
